export default __webpack_public_path__ + "static/media/wins.0c127e9d.svg";